export default "__VITE_ASSET__CHStGg5V__"